"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mui = require("tss-react/mui");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Stack = _interopRequireDefault(require("@mui/material/Stack"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _ChevronLeft = _interopRequireDefault(require("@mui/icons-material/ChevronLeft"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _mui.makeStyles)()(function (theme) {
  var _buttonContainer;
  return {
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%'
    },
    titleContainer: _objectSpread({
      borderBottom: '1px solid',
      borderColor: theme.palette.lightGrey.main,
      position: 'sticky',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0px 3px 3px -2px rgba(0, 0, 0, 0.2)',
      zIndex: 1
    }, theme.mixins.toolbar),
    title: _defineProperty({
      flexGrow: 1,
      maxWidth: 'calc(100% - 112px)',
      overflow: 'hidden',
      marginBottom: 0,
      textAlign: 'left'
    }, theme.breakpoints.down('md'), {
      textAlign: 'center'
    }),
    drawerIconButtonContainer: {
      width: 56,
      display: 'flex',
      justifyContent: 'center'
    },
    drawerIconButton: _defineProperty({
      height: 20,
      width: 20,
      color: theme.palette.primary.main
    }, theme.breakpoints.down('md'), {
      backgroundColor: theme.palette.background["default"]
    }),
    childrenContainer: _defineProperty({
      flexGrow: 1,
      overflowY: 'auto',
      backgroundColor: theme.palette.background["default"],
      padding: theme.spacing(5, 7)
    }, theme.breakpoints.down('md'), {
      padding: theme.spacing(3)
    }),
    buttonContainer: (_buttonContainer = {
      padding: theme.spacing(3, 7)
    }, _defineProperty(_buttonContainer, theme.breakpoints.down('md'), {
      padding: theme.spacing(2)
    }), _defineProperty(_buttonContainer, "borderTop", '1px solid'), _defineProperty(_buttonContainer, "borderColor", theme.palette.lightGrey.main), _buttonContainer)
  };
});
var DrawerContent = function DrawerContent(_ref) {
  var children = _ref.children,
    title = _ref.title,
    exitVariant = _ref.exitVariant,
    handleClose = _ref.handleClose,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    Wrapper = _ref.Wrapper,
    WrapperProps = _ref.WrapperProps;
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, _extends({}, WrapperProps, {
    className: cx(WrapperProps === null || WrapperProps === void 0 ? void 0 : WrapperProps.className, classes.contentWrapper)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.titleContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.drawerIconButtonContainer
  }, exitVariant === 'back' && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: classes.drawerIconButton,
    onClick: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_ChevronLeft["default"], null))), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h3",
    className: classes.title
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.drawerIconButtonContainer
  }, exitVariant === 'close' && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: classes.drawerIconButton,
    onClick: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.childrenContainer
  }, children), (!!primaryButton || !!secondaryButton) && /*#__PURE__*/_react["default"].createElement(_Stack["default"], {
    className: classes.buttonContainer,
    direction: {
      sm: 'column',
      md: 'row-reverse'
    },
    spacing: {
      sm: 1,
      md: 2
    }
  }, primaryButton, secondaryButton));
};
DrawerContent.propTypes = {
  children: _propTypes["default"].node.isRequired,
  handleClose: _propTypes["default"].func.isRequired,
  exitVariant: _propTypes["default"].oneOf(['close', 'back']),
  title: _propTypes["default"].string.isRequired,
  primaryButton: _propTypes["default"].node,
  secondaryButton: _propTypes["default"].node,
  Wrapper: _propTypes["default"].elementType,
  WrapperProps: _propTypes["default"].objectOf(_propTypes["default"].any) // eslint-disable-line react/forbid-prop-types
};

DrawerContent.defaultProps = {
  exitVariant: 'close',
  primaryButton: undefined,
  secondaryButton: undefined,
  Wrapper: 'div',
  WrapperProps: undefined
};
var _default = DrawerContent;
exports["default"] = _default;